export class PasswordData {
  title: string;
  username: string;
  oldpassword: string;
  newpassword: string;
  confirmpassword: string;
}
